import { Box as MuiBox } from "@mui/material";
import { cn } from "@/src/shared/utils/mergeTwClasses";

export function FlexBox(props: any) {
  return <MuiBox {...props} className={cn("flex", props.className)} />;
}
